<template>
    <div class="d-flex flex-column w-100">
        <navBar/>
		<banner titulo="Gerenciar CAT" subTitulo="Gerenciar Comunicados de Acidentes de Trabalho"/>
        <div class="d-flex flex-md-row flex-wrap flex-column w-75 mx-auto mt-2 p-md-5 p-3 gap-md borda">
            <div class="d-flex w-100 justify-content-start h-50" v-if="mostrarFormularioCat">
                <b-button variant="dark" @click="fecharFormularioCat()">Voltar</b-button>
            </div>
            <formularioCat ref="formularioCat" v-if="mostrarFormularioCat" :idCat="idCatSelecionado"/>
			<div v-else class="d-flex flex-column w-100">
				<form class="d-flex flex-column gap-md w-100">
                <div class="d-flex flex-md-row flex-column w-100 gap-md">
                    <div class="d-flex flex-column w-100">
                        <label>CPF Solicitante:</label>
						<autoCompletePessoaFisica ref="filtroPessoaFisica" @pessoaSelecionada="setaCpfPessoaFisicaPesquisada($event)"/>
                    </div>
                </div>
                <div class="d-flex flex-md-row flex-column w-100 gap-md">
                    <div class="d-flex flex-column w-100">
                        <label>Empresa:</label>
						<autoCompleteEmpresaCat ref="filtroEmpresaCat" @empresaSelecionada="setaCnpjEmpresaPesquisada($event)"/>
                    </div>
                </div>
                    <div class="d-flex flex-md-row flex-column gap-sm mx-md-0 mb-3 mx-auto" style="justify-content: space-between;">
                        <div class="d-flex gap-sm">
                            <b-button variant="primary" @click="filtrarCat">Filtrar</b-button>
                            <b-button variant="secondary" @click="limparFormularioFiltro">
                                Limpar
                            </b-button>
                        </div>
                    </div>
            </form>
            <b-table striped hover :items="items" :fields="fields" show-empty :responsive="true" :busy="carregandoBuscarCat">
                <template #empty>
                    <div class="d-flex">
                        <span class="mx-auto">
                            Nenhum Registro Encontrado
                        </span>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
				<template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
				<template #cell(solicitante)="data">
					{{ data.item.nomeSolicitante + " - " + $options.filters.addMascara(data.item.cpfSolicitante, "cpf")}}
				</template>
				<template #cell(empresa)="data">
					{{ data.item.razaoSocial }}
				</template>
				<template #cell(funcionario)="data">
					{{ data.item.nomeFuncionario + " - " + $options.filters.addMascara(data.item.cpfFuncionario, "cpf") }}
				</template>
				<template #cell(dataInicio)="data">
					{{ $options.filters.moment(data.item.dataInicio).format("DD/MM/YYYY HH:mm") }}
				</template>
				<template #cell(acao)="data">
					<b-dropdown variant="secondary" text="Selecione" boundary="window">
                        <b-dropdown-item @click="baixarArquivosCat(data.item.id)">
                            <font-awesome-icon icon="fa-solid fa-download" />
                            Baixar Arquivos
                        </b-dropdown-item>
						<b-dropdown-item @click="gerarExcelCat(data.item)">
							<font-awesome-icon :icon="['fas', 'file-export']" />
							Exportar Para Excel
                        </b-dropdown-item>
						<b-dropdown-item @click="visualizarCat(data.item.id)">
                            <font-awesome-icon icon="fa-solid fa-file" />
							Visualizar CAT
						</b-dropdown-item>
                    </b-dropdown>
				</template>
		</b-table>
		<div class="my-2 d-flex flex-column">
            <span>Total: {{ numeroDeLinhas }}</span>
        </div>
            <b-pagination class="mx-auto" v-model="paginaAtual" :total-rows="numeroDeLinhas" :per-page="catsPorPagina" @input="consultarCat"></b-pagination>
        </div>
			</div>

    </div>
</template>

<script>
import NavBar from "../../components/shared/NavBar.vue";
import Banner from "../../components/shared/Banner.vue";
import AutoCompletePessoaFisica from "../../components/pessoa/AutoCompletePessoaFisica.vue";
import FormularioCat from "../../components/Cat/FormularioCat.vue";
import CatService from "../../service/CatService.js";
import AutoCompleteEmpresaCat from "../../components/EmpresaCat/AutoCompleteEmpresaCat.vue";

export default{
	name: "GerenciarVue",
	components: {
		navBar: NavBar,
		banner: Banner,
		autoCompletePessoaFisica: AutoCompletePessoaFisica,
		autoCompleteEmpresaCat: AutoCompleteEmpresaCat,
		formularioCat: FormularioCat,
	},
	data() {
		return {
			mostrarFormularioCat: false,
			idCatSelecionado: 0,
			paginaAtual: 1,
			numeroDeLinhas: 0,
			catsPorPagina: 15,
			carregandoBuscarCat: false,

			items: [],
			fields: [
				{
					label: "#",
				 	key: "index",
				},
				{
					label: "Solicitante",
					key: "solicitante",
				},
				{
					label: "Funcionário",
					key: "funcionario",
				},
				{
					label: "Empresa",
					key: "empresa",
				},
				{
					label: "Data/Hora Envio",
					key: "dataInicio",
				},
				{
					label: "",
					key: "acao",
				},
			],

			filtros: {
				cpfUsuario: "",
				cnpjUsuario: "",
			},
		};
	},
	created() {
		this.filtrarCat();
	},
	methods: {
		gerarExcelCat(cat) {
			CatService.gerarRelatorioDetalhadoCat(cat.id)
				.then(res => this.$fileUtils.baixarArquivo(res.data, ("Cat_" + this.$options.filters.moment().format("DD-MM-YYYY") + "_" + cat.razaoSocial + ".xlsx")))
				.catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível gerar o excel nesse momento, por favor tente novamente mais tarde", "Erro", "danger");
					}
				});
		},
		baixarArquivosCat(id) {
			CatService.baixarArquivosCat(id)
				.then((res) => {
					Array.from(res.data).forEach((d) => {
						this.$fileUtils.baixarArquivo(d.arquivo, d.nomeArquivo);
					});
				}).catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível realizar o download dos arquivos nesse momento, por favor tente novamente mais tarde", "Erro", "danger");
					}
				});
		},
		filtrarCat() {
			this.paginaAtual = 1;
			this.consultarCat();
		},
		consultarCat() {
			this.carregandoBuscarCat = true;
			CatService.consultarCat(
				this.filtros.cpfUsuario,
				this.filtros.cnpjUsuario,
				this.paginaAtual - 1,
				this.catsPorPagina,
			)
				.then((res) => {
					this.items = res.data.items;
					this.numeroDeLinhas = res.data.qtdTotalItems;
				})
				.catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Nã foi possível consultar os CATs nesse momento, por favor tente novamente mais tarde", "Erro", "danger");
					}
				})
				.finally(() => {
					this.carregandoBuscarCat = false;
				});
		},
		limparFormularioFiltro() {
			this.$refs.filtroPessoaFisica.limpar();
			this.$refs.filtroEmpresaCat.limpar();
			this.filtros.cpfUsuario = "";
			this.filtros.cnpjUsuario = "";
		},
		setaCpfPessoaFisicaPesquisada(cpf) {
			this.filtros.cpfUsuario = cpf;
		},
		setaCnpjEmpresaPesquisada(cnpj) {
			this.filtros.cnpjUsuario = cnpj;
		},
		visualizarCat(id) {
			this.idCatSelecionado = id;
			this.mostrarFormularioCat = true;
		},
		fecharFormularioCat() {
			this.idCatSelecionado = 0;
			this.mostrarFormularioCat = false;
			this.filtrarCat();
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/views/cat/GerenciarCat.vue